module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('xm-modal', {
    attrs: {
      "title": "Update Password",
      "size": "lg",
      "save-text": "Change password",
      "save": _vm.changePassword,
      "save-disabled": _vm.changePasswordDisabled,
      "id": "change-password-modal"
    }
  }, [_c('div', [_c('password-form', {
    attrs: {
      "require-old-password": true,
      "password-in-modal": true
    },
    on: {
      "input": _vm.setPasswordDetails,
      "form-state": _vm.setPasswordDetailsValid
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b7eb36d8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modals/ChangePasswordModal.vue
// module id = 1435
// module chunks = 3 5